export default function productSearch() {
	const $conditions = document.getElementById("product_condition");
	if (document.getElementById("product_condition")!==null) {
		const apps = document.getElementsByName("application");
		const tons = document.getElementsByName("ton");
		const beds = document.getElementsByName("bed");
		const stks = document.getElementsByName("stroke");
		const prds = Array.prototype.slice.call(document.querySelectorAll(".aida_product_index_card"), 0)
		//document.getElementsByClassName("aida_product_index_card");

		const conditions = {
			apps: [],
			tons: [],
			beds: [],
			stks: [],
		}
		
		apps.forEach(app => {
			app.addEventListener("change", function() {
				conditions.apps =getChecked(apps);
				const choosed = checkAttibute();
				drawCards(choosed);
			});
		});
		tons.forEach(ton => {
			ton.addEventListener("change", function() {
				conditions.tons =getChecked(tons);
				const choosed = checkAttibute();
				drawCards(choosed);
			});
		});
		beds.forEach(bed => {
			bed.addEventListener("change", function() {
				conditions.beds =getChecked(beds);
				const choosed = checkAttibute();
				drawCards(choosed);
			});
		});
		stks.forEach(stk => {
			stk.addEventListener("change", function() {
				conditions.stks =getChecked(stks);
				const choosed = checkAttibute();
				drawCards(choosed);
			});
		});

		function getChecked(arr=[]) {
			const arrChecked = [];
			arr.forEach(el=>{
				if (el.checked) {
					arrChecked.push(el.getAttribute("value"))
				}
			})
			// console.log(arrChecked);
			return arrChecked;
		}

		function checkAttibute() {
			//console.log(conditions);//選択内容
			///適合内容保存用
			const choosedPrds = {
				apps: [],
				tons: [],
				beds: [],
				stks: [],
			}
			//製品一つ一つを条件チェック
			if (conditions.apps.length>0) {
				const tmpArr = [];
				prds.forEach(prd => {
				//Application 条件をチェック
					conditions.apps.forEach(app => {
						const hit = prd.getAttribute(`data-${app}`);
						if (hit) {
							tmpArr.push(prd);
							// console.log(prd.getElementsByClassName("_name")[0].innerText);
						}
					})
				})
				choosedPrds.apps = tmpArr.filter((x, i, self) => self.indexOf(x) === i);
			} else {
				choosedPrds.apps = Array.from(prds);
			}

			if (conditions.tons.length>0) {
				const tmpArr = [];
				choosedPrds.apps.forEach(app => {
				//Tonnage
					conditions.tons.forEach(ton => {
						//条件
						const minCond = Number(ton.split("-")[0]);
						const maxCond = Number(ton.split("-")[1]);
						//設定値
						const minVal = Number(app.getAttribute("data-ton-min"));
						const maxVal = Number(app.getAttribute("data-ton-max"));
						//('ton-min') >= 300 && ('ton-min') <= 800 || ('ton-min') <= 800 && ('ton-max') >= 300
						if ((minVal>=minCond && minVal<=maxCond && minVal>=1) || (minVal<=maxCond && maxVal>=minCond && minVal>=1 && maxVal>=1)) {
							tmpArr.push(app);
							// console.log(prd.getElementsByClassName("_name")[0].innerText);
						}
					})
				})
				choosedPrds.tons = tmpArr.filter((x, i, self) => self.indexOf(x) === i);
			} else {
				choosedPrds.tons = Array.from(choosedPrds.apps)
			}
			if (conditions.beds.length>0) {
				const tmpArr = [];
				choosedPrds.tons.forEach(ton => {
				//Bolster 
					conditions.beds.forEach(bed => {
						//条件
						const minCond = Number(bed.split("-")[0]);
						const maxCond = Number(bed.split("-")[1]);
						//設定値
						const minVal = Number(ton.getAttribute("data-bed-min"));
						const maxVal = Number(ton.getAttribute("data-bed-max"));
						if ((minVal>=minCond && minVal<=maxCond && minVal>=1) || (minVal<=maxCond && maxVal>=minCond && minVal>=1 && maxVal>=1)) {
							tmpArr.push(ton);
						}
					})
				})
				choosedPrds.beds = tmpArr.filter((x, i, self) => self.indexOf(x) === i);
			} else {
				choosedPrds.beds = Array.from(choosedPrds.tons)
			}
			if (conditions.stks.length>0) {
				const tmpArr = [];
				choosedPrds.beds.forEach(bed => {
					//Bolster 
					conditions.stks.forEach(stk => {
						//条件
						const minCond = Number(stk.split("-")[0]);
						const maxCond = Number(stk.split("-")[1]);
						//設定値
						const minVal = Number(bed.getAttribute("data-stk-min"));
						const maxVal = Number(bed.getAttribute("data-stk-max"));
						if ((minVal>=minCond && minVal<=maxCond && minVal>=1) || (minVal<=maxCond && maxVal>=minCond && minVal>=1 && maxVal>=1)) {
							tmpArr.push(bed);
						}
					})
				})
				choosedPrds.stks = tmpArr.filter((x, i, self) => self.indexOf(x) === i);
			} else {
				choosedPrds.stks = Array.from(choosedPrds.beds)
			}
			
			return choosedPrds.stks;
		}

		function drawCards(choosedPrds) {
			prds.forEach(prd => {
				prd.classList.add("_hide");
			});
			choosedPrds.forEach(ch => {
				ch.classList.remove("_hide");
			});
			const result = document.getElementById("num_results");
			if (choosedPrds.length>0) {
				result.innerText = `Number of Matching Product[s]: ${choosedPrds.length}`;
			} else {
				result.innerText = `Please change the parameters.`;
			}
			const checkedNum = document.querySelectorAll('input[type="checkbox"]:checked').length;
			if (checkedNum===0) {
				result.innerText = `Please select the parameters.`;
			}
		}
	}
}